export default {
  categories: [],
  tags: [],
  topics: [],
  bestUsers: [],
  topic: {},
  comments: [],
  count: null
};
